import './FormTable.scss'
import React,{useState, useEffect, useRef} from 'react'
import {Table, Row, Col, message, Icon, Checkbox, Button, Pagination, Modal, Dropdown, Menu, Tooltip, Input} from 'antd'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { getItemsPromise, sendRemindersOnbPromise, deleteDeclarationsPromise } from '../../promises'
import {ModalIndexCardPage} from '../../components'
import {ModalPdfViewer} from '../../../../../InterestConflicts/components'
import { AdvancedTabsComponent } from '../../components';

const FormTable = ({currentUser, areas, filtersSideBar, categories}) => {

	const [isAdvancedSearchVisible, setIsAdvancedSearchVisible] = useState(null)
	const [rut, setRut] = useState(null)
	const [itemTable, setItemTable] = useState(null)
  	const { t } = useTranslation()
	const [items, setItems] = useState([])
	const [isItemsLoading, setIsItemsLoading] = useState(false)
	const [currentPage, setCurrentPage] = useState(1)
	const [itemsTotalNum, setItemsTotalNum] = useState(-1)
	const [enableReminders, setEnableReminders] = useState(false)
	const [chkAll, setChkAll] = useState(false);
	const itemsPerPage = 10
	const [filters, setFilters] = useState(filtersSideBar);
	const [formId, setFormId] = useState(null);
	const [confirm, setConfirm] = useState(null);
	const [option, setOption] = useState(null);
	const [pendientesCount, setPendientesCount] = useState(0);
	const [rechazadasCount, setRechazadasCount] = useState(0);
	const [autorizadasCount, setAutorizadasCount] = useState(0);
	const [evaluacionCount, setEvaluacionCount] = useState(0);
	const [observadasCount, setObservadasCount] = useState(0);
	const [sortField, setSortField] = useState(null);
	const [sortDirection, setSortDirection] = useState(null);
	const [selectedItem, setSelectedItem] = useState([]);
	const filtersRef = useRef(filtersSideBar);
	const isFirstSidebarSync = useRef(true);

    // checkedList: defaultCheckedList,
    // indeterminate: true,
    // checkAll: false,

	useEffect(() =>{
		handlePaginationChange(1)
	},[rut])

	useEffect(() => { filtersRef.current = filters; }, [filters]);

	useEffect(() => {
		if (isFirstSidebarSync.current) {
			isFirstSidebarSync.current = false;
			return;
		}
		if (Object.keys(filtersSideBar || {}).length === 0) return;
		const merged = { ...filtersSideBar, ...filtersRef.current };
		setFilters(merged);
		handleSearch(1, merged, sortField, sortDirection);
	}, [filtersSideBar])

	const handleSelectDeselectAll = (e) => {
		setChkAll(e.target.checked)
		setEnableReminders(e.target.checked)
		if(!e.target.checked){
			setSelectedItem([])
		}else{
			let itemsPerPage = [];
			items.map(i => itemsPerPage.push(i.id))
			setSelectedItem(itemsPerPage);
		}
	}

	const handleMenuClick = (e) => {
		const action = e.key;
		setOption(action);
		setConfirm(true);
	}

	const handlePaginationChange = async (value) => {
		handleSearch(value, filters, sortField, sortDirection)
	}

	const menu = (
		<Menu onClick={handleMenuClick}>
			<Menu.Item key="1">
				<Icon type="mail" /> {t('messages.aml.cdi.forms.sendReminders')}
			</Menu.Item>
			<Menu.Item key="2">
				<Icon type="delete" /> {t('messages.aml.cdi.forms.delete')}
			</Menu.Item>
		</Menu>
	);

	const handleSendReminder = () => {
		if(selectedItem.length > 0){
			sendRemindersOnbPromise('CDI', filters, selectedItem).then((response) =>{
				if(response.success){
					message.success(t("messages.aml.formTable.remindersSentSuccess"));
					setConfirm(false)
					setOption(null)
					handlePaginationChange(currentPage)
				}else{
					message.error(t('messages.aml.formTable.remindersSentError'))
				}
			})
			setConfirm(false);
		}else{
			message.error(t("messages.aml.formTable.noItemsSelected"))
		}
	}

	const handleDeletePendings = () => {
		if(selectedItem.length > 0){
			deleteDeclarationsPromise('CDI', filters, selectedItem).then((response) =>{
				if(response.success){
					message.success(t('messages.aml.cdi.forms.deletedSuccess'));
					setConfirm(false)
					setOption(null)
					handlePaginationChange(currentPage)
				}else{
					message.error(t('messages.aml.notifications.anErrorOcurred'))
				}
			})
			setConfirm(false);
		}else{
			message.error(t("messages.aml.formTable.noItemsSelected"))
		}
	}

	const handleSearch = async (page, filters, sorField=null, sortDirection=null) => {

		const fromNum = ((page - 1) * itemsPerPage)
		filters.from = fromNum;
		filters.size = itemsPerPage;
		//filters.category = categoria;
		filters.rutNombre = rut;
		filters.sorField = sorField;
		filters.sortDirection = sortDirection;
		setIsItemsLoading(true)


		const items = await getItemsPromise("CDI", filters)
		setItemsTotalNum(items.data.total)
		setItems(items.data.records)
		setChkAll(false);
		setSelectedItem([]);
		setPendientesCount(0)
		setEvaluacionCount(0)
        setObservadasCount(0)
		setRechazadasCount(0)
		setAutorizadasCount(0)

		// acumular valores para items.data.filters.tipo, sumando total agrupado por tipo
		if(items.data.filters && items.data.filters.status) {
			const status = items.data.filters.status;
			const categoriesCounts = {};
			const tipoCounts = {};
			status.forEach(st => {
				if(categoriesCounts[st.categoria]) {
					categoriesCounts[st.categoria] += st.total;
				} else {
					categoriesCounts[st.categoria] = st.total;
				}
				if(tipoCounts[st.tipo]) {
					tipoCounts[st.tipo] += st.total;
				} else {
					tipoCounts[st.tipo] = st.total;
				}
			});
        }

		if(items.data.filters && items.data.filters.status) {
			const pendientes = items.data.filters.status.filter(s => s.status === 'PENDIENTE')
			if(pendientes.length > 0) setPendientesCount(pendientes.reduce((acc, value) => {return acc+value.total},0))

			const evaluacion = items.data.filters.status.filter(s => s.status === 'EVALUACION')
			if(evaluacion.length > 0) setEvaluacionCount(evaluacion.reduce((acc, value) => {return acc+value.total},0))

			const rechazadas = items.data.filters.status.filter(s => s.status === 'RECHAZADA')
			if(rechazadas.length > 0) setRechazadasCount(rechazadas.reduce((acc, value) => {return acc+value.total},0))

			const autorizadas = items.data.filters.status.filter(s => s.status === 'AUTORIZADA')
			if(autorizadas.length > 0) setAutorizadasCount(autorizadas.reduce((acc, value) => {return acc+value.total},0))

            const observadas = items.data.filters.status.filter(s => s.status === 'OBSERVADA')
			if(observadas.length > 0) setObservadasCount(observadas.reduce((acc, value) => {return acc+value.total},0))
		}

		setCurrentPage(page)
		setIsItemsLoading(false)
	}

	const cbFilters = (objFilters) => {
		const merged = { ...filtersSideBar, ...objFilters };
		setFilters(merged);
		handleSearch(1, merged, sortField, sortDirection);
	};

	const handleCancel = () => {
		handleSearch(currentPage, filters, sortField, sortDirection)
		setItemTable(null);
	};

	const onCancelPdfViewer = () => {
			setFormId(null);
	}

	const changeTable = (pagination, tableFilters, sorter, currentPageData) => {
		let sF = null
		let sD = null
		if(sorter.order) {
			sF = sorter.field
			sD = sorter.order === 'ascend' ? 'asc' : 'desc'
		}
		setSortField(sF)
		setSortDirection(sD)

		const activeFilters = filtersRef.current || filters;
		handleSearch(currentPage, activeFilters, sF, sD)
		return false
	}

	const handlePdfViewer = (record) => {
		setFormId(record.id);
	}

	const handleShowIndexCard = (record) => {
		setItemTable(record)
	}

  const getTableColumns = () => {
		let columns = [
      		{
				title: () => (
					<div>
						<Checkbox onChange={handleSelectDeselectAll} checked={chkAll} />
					</div>
				),
				width: 43,
				align: 'center',
				render: (text, record) => {
					if (record.statusDecl === 'PENDIENTE') {
						return <Checkbox
						checked={selectedItem.filter(i => i === record.id).length > 0}
						onChange={(e) => {
							setChkAll(false)
							let checkedItem = [...selectedItem]
							if(e.target.checked) {
								checkedItem.push(record.id)
							}else{
								checkedItem = checkedItem.filter(i => i !== record.id)
							}
							setSelectedItem(checkedItem)
							setEnableReminders(checkedItem.length > 0)
						}}
						/>
					}
				}
			},
			{
				title: t('messages.aml.category'),
				dataIndex: "category",
				sorter:  (a, b) => {return false},
				render: (text) => {
					return text ? t("messages.aml.category."+text) : "N/A"
				}
			},
			{
				title: t('messages.aml.cdi.forms.nameRut'),
				width: 150,
				elipsis: true,
				dataIndex: 'name',
				render: ((name, record) => {
					return <>
						<div className="name-col-table">
							<Button type="link" onClick={ () => handleShowIndexCard(record) }>{name}</Button>
							<Button type="link" onClick={ () => handleShowIndexCard(record) }>{record.rut}</Button>
						</div>
					</>
				}),
				sorter: (a, b) => { return false }
			},
			{
				title: t('messages.aml.cdi.forms.type'),
				dataIndex: "type",
				width: 100,
				render: type => t("messages.aml.type."+type)
			},
			{
				title: t('messages.aml.folio'),
				dataIndex: 'folio',
	            width: 130,
				sorter: (a, b) => { return false }
			},
			{
				title: t('messages.aml.cdi.forms.requestDate'),
				width: 110,
				dataIndex: 'sendDate',
				render: (text) => {
					return moment(text).format('DD/MM/YYYY')
				},
				sorter: (a, b) => { return false }
			},
			{
				title: t('messages.aml.cdi.forms.statusDate'),
				width: 120,
				dataIndex: 'statusDecl',
				render: (text, record) => { 
					return <>
						<span>{t("messages.aml.formKycStatus."+text)}</span>
						<br/>
						<span>{moment(record.statusDate).format('DD/MM/YYYY')}</span>
					</>
				}
				,
				sorter: (a, b) => { return false }
			},
			{
				title: () => <Tooltip title={t('messages.aml.cdi.forms.info')}><Icon type="info-circle" style={{fontSize:18}}/></Tooltip>,
				width: 100,
				align: 'center',
				render: (record) =>
				<Row>
					{record.hasPositives &&
						<Col span={12}>
							<Tooltip title={t('messages.aml.cdi.forms.hasLinks')}>
								<Icon type="link" style={{fontSize: 20}}/>
							</Tooltip>
						</Col>
					}
					{record.lastReminder &&
						<Col span={12}>
							<Tooltip title={t('messages.aml.cdi.forms.lastReminderDate', { date: moment(record.lastReminder).format('DD/MM/YYYY') })}>
								<Icon type="mail" style={{fontSize: 20}}/>
							</Tooltip>
						</Col>
					}
				</Row>
				
			},
			{
				width: 60,
				align: 'center',
				title: () => <Tooltip title={t('messages.aml.report.type.DECL')}><Icon type="file-pdf" className="file-pdf" style={{fontSize: '20px'}}/></Tooltip>,
				render: ((record) => {
					return(
						<Row>
							<Col span={24}>
							<div style={{textAlign:"center"}}>
								{ record.statusDecl !== 'PENDIENTE' &&
									<Icon type="file-pdf" className="file-pdf"
											onClick={ () =>
											handlePdfViewer(record) }
											style={{fontSize: '20px'}}
									/>
								}
							</div>
							</Col>
						</Row>
					)
				}
				)
			}
		]

		return columns
	}

    return (
        <div className="formTable-content">
					<Row type="flex" justify="center">
						<Col  span={4} offset={0}>
							<div className="solicitudes-card">
								{t('messages.aml.pending')} <br/>
								{pendientesCount}
							</div>
						</Col>
						<Col span={4} offset={1}>
							<div className="solicitudes-card">
								{t('messages.aml.completed')} <br/>
								{evaluacionCount}
							</div>
						</Col>
						<Col span={4} offset={1}>
							<div className="solicitudes-card">
								{t('messages.aml.cdi.status.authorizedPlural')} <br/>
								{autorizadasCount}
							</div>
						</Col>
						<Col span={4} offset={1}>
							<div className="solicitudes-card">
								{t('messages.aml.cdi.status.rejectedPlural')} <br/>
								{rechazadasCount}
							</div>
						</Col>
                        <Col span={4} offset={1}>
							<div className="solicitudes-card">
								{t('messages.aml.cdi.status.observedPlural')} <br/>
								{observadasCount}
							</div>
						</Col>
						<Modal
							title={option === "1" ? t('messages.aml.cdi.forms.sendReminderTitle') : t('messages.aml.cdi.forms.deletePendingTitle')}
							visible={confirm}
							onCancel={() => setConfirm(false)}
							okText={option === "1" ? t('messages.aml.cdi.forms.send') : t('messages.aml.cdi.forms.delete')}
							maskClosable={false}
							centered={true}
							footer={option==="1"?
							[<Button onClick={handleSendReminder} type="primary">{t('messages.aml.cdi.forms.send')}</Button>]
							:
							[<Button onClick={handleDeletePendings} type="danger">{t('messages.aml.cdi.forms.delete')}</Button>]
							}
							>
							<h3>{option === "1" ?
								t('messages.aml.cdi.forms.sendReminderConfirm')
								:
								t('messages.aml.cdi.forms.deleteConfirm')}
							</h3>
						</Modal>
					</Row>
                    <Row type="flex"  style={{ marginTop: 10 , marginBottom: 5 }}>
                        <Col span={12}>
                            <Input.Search
                                placeholder={t('messages.aml.cdi.forms.searchPlaceholder')}
                                style={{ width: "100%", marginTop: "0px"}}
                                onSearch={(value) => {setRut(value)}}
                                allowClear
                            />
                        </Col>
                        <Col span={1} >
                            <div className={isAdvancedSearchVisible ? 'advanced-search on' : 'advanced-search'} onClick={!isAdvancedSearchVisible ? () => {setIsAdvancedSearchVisible(true)} : () => {setIsAdvancedSearchVisible(false)}}>
                                <Icon style={{fontSize: '20px', marginTop: 5, marginLeft: 10, cursor: 'pointer'}} type={!isAdvancedSearchVisible ? 'filter' : 'close'} />
                            </div>
                        </Col>
                        <Col span={5} push={6}>
                            <div className="action-button-form">
                                <Dropdown overlay={menu} disabled={!enableReminders}>
                                    <Button style={{marginTop: 8}}>
                                        {t('messages.aml.cdi.forms.action')} <Icon type="down" />
                                    </Button>
                                </Dropdown>
                            </div>
                        </Col>
                    </Row>
					<Row>
						<Col span={24}>
							<div className={isAdvancedSearchVisible === null ? 'filters-wrapper null' : (isAdvancedSearchVisible ? 'filters-wrapper show' : 'filters-wrapper hide')}>
								<div className="filters-wrapper-inner">
									<AdvancedTabsComponent cbFilters={cbFilters} areas={areas} currentUser={currentUser} categories={categories} />
								</div>
							</div>
						</Col>
					</Row>
					<div className="table-req-onb">
						<Row>
							<Col span={24}>
								<Table
									size="small"
									pagination={false}
									columns={getTableColumns()}
									dataSource={items}
									onChange={changeTable}
									loading={isItemsLoading}/>
							</Col>
						</Row>
						{formId &&
							<Modal
							className="modal-pdf-viewer"
							title={t('messages.aml.report.type.DECL')}
							centered={true}
							width={1000}
							header={null}
							footer={false}
							onCancel={onCancelPdfViewer}
							visible={true}
							><ModalPdfViewer
								pdfId={formId}
							/>
							</Modal>
						}
						<div className="pagination-formtable">
							<Row>
								{itemsTotalNum > 0 &&
									<Pagination
										onChange={handlePaginationChange} pageSize={itemsPerPage} current={currentPage} total={itemsTotalNum}
									/>
								}
							</Row>
						</div>
					</div>

					{itemTable &&
						<Modal
							wrapClassName="modal-index-card"
							title={ <div>
										<Row>
											<Col span={8}>
												{t('messages.aml.cdi.formManager.declarationsOf', { category: t("messages.aml.category."+itemTable.category) })}
											</Col>
											<Col>
												<div style={{float:'right', paddingRight: 20}}>{t('messages.aml.folio')}: {itemTable.folio}</div>
											</Col>
										</Row>
									</div>
								}
							visible={true}
							onCancel={handleCancel}
							cancelText={t('messages.aml.btnClose')}
							footer={null}
							width={1200}
							style={{top:"10px"}}
						>
							<ModalIndexCardPage item={itemTable} handleCancel={handleCancel}/>
						</Modal>
					}
        </div>
    )
}

export default FormTable
